import React, { useContext, useReducer, useEffect, useState, useRef } from "react";
import {FormattedMessage} from 'react-intl';
import AppContext from "../components/AppContext";

function GlobalAlerts({ flashAlerts = {} }) {
	const [, forceUpdate] = useReducer(x => x + 1, 0);
	const appContext = useContext(AppContext);
	appContext.updateAlerts = forceUpdate; 

	const alertsContainerRef = useRef(null);

	useEffect(() => {
		const updateHeightVariable = () => {
			const minHeight = 40; // the height below the top
			if (alertsContainerRef.current) {
				const height = alertsContainerRef.current.getBoundingClientRect().height + minHeight;
				document.documentElement.style.setProperty('--alerts-height', `${height}px`);
			} else {
				document.documentElement.style.setProperty('--alerts-height', `${minHeight}px`);
			}
		};
	
		// Initial update
		updateHeightVariable();
	
		// Set up ResizeObserver
		const resizeObserver = new ResizeObserver(() => {
			updateHeightVariable();
		});
	
		if (alertsContainerRef.current) {
			resizeObserver.observe(alertsContainerRef.current);
		}
	
		// Cleanup
		return () => {
			if (alertsContainerRef.current) {
				resizeObserver.unobserve(alertsContainerRef.current);
			}
		};
	}, [flashAlerts, alertsContainerRef.current]);

	const contentRef = useRef(null);
    const [shouldScroll, setShouldScroll] = useState(false);

	const lineHeight = 1.8; // 1.8em is a message line height sufficient to show a partial 5th line and give a visual cue that scrolling is required
	
	useEffect(() => {
        if (contentRef.current) {
            const maxHeight = lineHeight * 4;
            const actualHeight = contentRef.current.scrollHeight;
            
            setShouldScroll(actualHeight > maxHeight);
        }
    }, [flashAlerts]); // Re-run when messages change

	const renderAlert = (type, prop, headerMessage, mouseEnterId, alertClassName, timerBarId) => {
		return ( 
			<div id={mouseEnterId} onMouseEnter={() => {
					if(flashAlerts[type]?.duration !== -1) {               
						let msgObj=prop; 
						msgObj.duration=-1; 
						flashAlerts[type] = msgObj;
						forceUpdate();  
					}}
				}
			>
			  <section className={"alert "+alertClassName}>
				<h3>
				  {headerMessage}!
				  {renderAlertClose(type, prop?.duration ?? 0)}
				</h3>
				<div ref={contentRef}
					style={{
						maxHeight: 'calc('+lineHeight+'em * 4 + '+lineHeight/2+'em)',
						overflowY: shouldScroll ? 'auto' : 'hidden',
						overflowX: 'hidden',
						wordWrap: 'break-word' // Ensures long words wrap
					}}>
					{prop.messages.map(function(msg, index) {
						return (
							<div key={type+"Msg-"+index}>{msg}</div>
						);
					})}
				</div>
			  </section>
			  <span id={timerBarId} className={"alert "+alertClassName+" alertTimerBar"} style={{width:'0%'}}></span>
			</div>
		)
	}
	
	const renderAlertClose = (setFlashType, duration) => {
		if (setFlashType && duration < 0) {
			return <button type="button" className="mfp-close" id="globalAlertClose" onClick={()=>{
				flashAlerts[setFlashType] = null;
				forceUpdate();
			}} >×
			</button>
		}
		return <></>;
	}

	if ((flashAlerts?.flashSuccess?.messages || flashAlerts?.flashNotice?.messages || flashAlerts?.flashWarning?.messages || flashAlerts?.flashError?.messages)) {
		return (
			<>
				<div 
					id="global-alerts-container" 
					ref={alertsContainerRef}
					className="row"
					style={{
						position: 'sticky',
						top: '0px', // This defines where the stickiness starts from
						zIndex: 500, // Ensure it's above other content
					}}
				>
					<section className="global-alert">
						{flashAlerts?.flashSuccess ? renderAlert("flashSuccess", flashAlerts.flashSuccess,  <FormattedMessage id="globalAlert.success" />, "mouse-enter-s", "alert-success", "successAlertTimerBar") : ""}
						{flashAlerts?.flashNotice ? renderAlert("flashNotice", flashAlerts.flashNotice,  <FormattedMessage id="globalAlert.notice" />, "mouse-enter-n", "alert-info", "noticeAlertTimerBar") : ""}
						{flashAlerts?.flashWarning ? renderAlert("flashWarning", flashAlerts.flashWarning, <FormattedMessage id="globalAlert.warning" />, "mouse-enter-w", "alert-warning", "warningAlertTimerBar") : ""}
						{flashAlerts?.flashError ? renderAlert("flashError", flashAlerts.flashError,  <FormattedMessage id="globalAlert.error" />, "mouse-enter-e", "alert-danger", "errorAlertTimerBar") : ""}
					</section>
				</div>
			</>
		);
	}
	return <></>;
}

export default GlobalAlerts;